import { FC, SVGProps } from "react";

const DashedSeparatorIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 20 2" fill="none" stroke="currentcolor" strokeWidth="1.6" {...props}>
      <line x1="0" y1="1" x2="20" y2="1" />
    </svg>
  );
};

export default DashedSeparatorIcon;
